<template>
  <div class="wrap">
    <Layout>
      <Header>
        <top-nav></top-nav>
      </Header>
      <Layout>
        <Sider hide-trigger width="240" style="overflow: auto;">
          <div class="user-info">
            <div class="user-message">
              <p><span>姓名</span><span class="space">|</span><span class="text">{{$store.state.user.name}}</span></p>
              <p><span>学校</span><span class="space">|</span><span class="text">{{$store.state.user.schoolName}}</span></p>
            </div>
          </div>
          <!--<left-nav></left-nav>-->
          <ul class="left-menu">
            <li v-for="menu in menuConfig" :key="menu.menuId" :class="activeName===menu.name?'current':''" v-if="menu.show" @click="pushRouter(menu)">
              <Icon :key="menu.icon" :type="menu.icon"></Icon>{{menu.label}}
            </li>
            <li class="border-left"></li>
          </ul>
        </Sider>
        <Content>
          <div class="right-menu-tab" v-if="mapPermission[activeName] && mapPermission[activeName].children && mapPermission[activeName].children.length > 0">
            <ul>
              <li v-for="tab in mapPermission[activeName].children"
                  class="tab-item"
                  v-if="tab.show"
                  :class="{'active-tab': tab.name === tabActive}"
                  :key="tab.menuId"
                  @click="changeTab(tab)"
              >{{ tab.label }}</li>
            </ul>
          </div>
          <main-router :level1="activeName" :level2="tabActive"></main-router>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import MenuConfig from '../../assets/js/menuConfig'
import LeftNav from './leftNav'
import TopNav from './topNav'
import MainRouter from './homeRouter'

export default {
  components: {MainRouter, TopNav, LeftNav},
  data () {
    return {
      menuConfig: [],
      mapPermission: {},
      activeName: '',
      tabActive: ''
    }
  },
  created () {
    const _self = this;
    let permission = JSON.parse(_self.$store.state.permission);
    let mapPermission = {};
    for (let menu of permission) {
      mapPermission[menu.url] = menu;
    }
    _self.menuConfig = MenuConfig;

    let curPath = _self.$route.path;
    for (let menu of _self.menuConfig) {
      if (mapPermission[menu.name]) {
        menu.show = true;
        menu.icon = mapPermission[menu.name].icon;
        // 存在二级目录
        if (mapPermission[menu.name].list && mapPermission[menu.name].list.length > 0 && menu.children && menu.children.length > 0) {
          let pageMap = {}
          menu.pageMap = {}
          for (let page of mapPermission[menu.name].list) {
            pageMap[page.url] = page;
          }
          for (let page of menu.children) {
            if (pageMap[page.name]) {
              if (page.subFlag) {
                page.show = false
              } else {
                page.show = true
              }
              page.icon = pageMap[page.name].icon;
              page.children = pageMap[page.name].list;
              if (page.url === curPath) {
                _self.activeName = menu.name;
                _self.tabActive = page.name;
              }
              menu.pageMap[page.name] = page;
            }
          }
        } else if (menu.url === curPath) {
          _self.activeName = menu.name;
          _self.tabActive = '';
        }
        _self.mapPermission[menu.name] = menu;
      } else {
        menu.show = false;
      }
    }
    _self.$store.commit('permissionInit', _self.mapPermission);
    // 刷新初始化当前页面的目录信息
  },
  watch: {
  },
  methods: {
    pushRouter (menu) {
      const _self = this;
      if (_self.activeName === menu.url) return;
      if (menu.url) {
        _self.activeName = menu.name;
        _self.tabActive = '';
        _self.$router.push({path: menu.url});
      } else if (menu.children) {
        let children = menu.children.filter(item => item.show);
        if (children.length > 0 && children[0].url) {
          _self.activeName = menu.name;
          _self.tabActive = children[0].name;
          _self.$router.push({path: children[0].url});
        } else {
          _self.$Message.warning('当前目录未配置有效页面');
        }
      } else {
        _self.$Message.warning('当前目录未配置有效页面');
      }
    },
    changeTab (tab) {
      const _self = this;
      _self.tabActive = tab.name;
      _self.$router.push({path: tab.url});
    }
  }
}
</script>

<style lang="less" scoped>
  .user-info {
    background-color: @layout-body-background;
    padding: 20px;
    .user-message {
      p {
        display: flex;
        font-size: @font-size-small;
        margin: 8px 0 0 20px;
        .space {
          padding: 0 4px;
        }
        .text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .left-menu {
    background-color: @body-background;
    padding: 6px 0;
    position: relative;
    li {
      cursor: pointer;
      height: 36px;
      line-height: 36px;
      margin: 10px 0;
      padding-left: 16px;
      i {
        display: inline-block;
        font-style: normal;
        height: 18px;
        width: 18px;
        margin-right: 16px;
        line-height: 17px;
        text-align: center;
        position: relative;
        z-index: 1;
      }
      &.border-left {
        bottom: 16px;
        left: 24px;
        height: auto;
        margin: 0;
        top: 16px;
        position: absolute;
        width: 1px;
        list-style: none;
      }
      &.current {
        color: @base-color;
        background-color: rgba(@base-color, .2);
        border-right: 4px @border-style-base @base-color;
        .border-all {
          border-color: @base-color;
        }
      }
      &:not(.border-left):hover {
        color: @base-color;
        background-color: rgba(@base-color, .2);
        .border-all {
          border-color: @base-color;
        }
      }
      &.student-stage {
        color: @base-color;
        .border-all {
          border-color: @base-color;
        }
        &.disabled-item {
          color: @text-color;
          .border-all {
            color: @border-color-base;
            border-color: @border-color-base;
          }
          &:hover {
            color: inherit;
            background-color: inherit;
            .border-all {
              border-color: inherit;
            }
          }
        }
      }
    }
  }
  .right-menu-tab {
    background-color: @body-background;
    border-top: @border-width-base @border-style-base @border-color-base;
    border-bottom: @border-width-base @border-style-base @base-color;
    margin: 6px 20px 0;
    ul {
      overflow: hidden;
      .tab-item {
        cursor: pointer;
        height: 36px;
        line-height: 36px;
        list-style: none;
        float: left;
        padding: 0 30px;
        &.active-tab {
          color: @base-color;
          background-color: rgba(@base-color, .2);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/home/index.vue